import { CurrencyPipe } from '@angular/common';
import { Column, GridRow } from '@shared';

export class SubstitutionException {
  @Column({
    title: 'Item Brink ID',
    field: 'parItemId',
    order: 1,
    width: 100,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
  })
  parItemId?: string;

  @Column({
    field: 'itemName',
    title: 'Item Name',
    order: 2,
    width: 200,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  itemName?: string;

  @Column({
    field: 'alc',
    title: 'Alc Price',
    order: 3,
    pipeToken: CurrencyPipe,
    width: 100,
    filterable: true,
    filterType: 'numeric',
    sortable: true,
    visibleInQuickView: true,
  })
  alc?: number;

  @Column({
    field: 'alcDlv',
    title: 'Alc Delivery Price',
    order: 4,
    pipeToken: CurrencyPipe,
    width: 120,
    filterable: true,
    filterType: 'numeric',
    sortable: true,
    visibleInQuickView: true,
  })
  alcDlv?: number;

  @Column({
    group: "Calculated Difference",
    groupHeaderClass: 'substitution-group-header',
    field: 'defaultSubs',
    title: 'Default Sub',
    order: 5,
    pipeToken: CurrencyPipe,
    width: 140,
    filterable: true,
    filterType: 'numeric',
    sortable: true,
    headerClass: 'substitution-group-start',
    class: 'substitution-group-start',
    visibleInQuickView: true,
  })
  defaultSubs?: number;

  @Column({
    group: "Calculated Difference",
    field: 'defaultSubsDlv',
    title: 'Default Sub Delivery',
    order: 6,
    pipeToken: CurrencyPipe,
    width: 180,
    filterable: true,
    filterType: 'numeric',
    sortable: true,
    visibleInQuickView: true,
  })
  defaultSubsDlv?: number;


  @Column({
    group: 'Current Substitution Pricing',
    groupHeaderClass: 'substitution-group-header',
    field: 'componentPrice',
    title: 'Current Sub Price',
    order: 7,
    pipeToken: CurrencyPipe,
    width: 120,
    filterable: true,
    filterType: 'numeric',
    sortable: true,
    headerClass: 'substitution-group-start',
    class: 'substitution-group-start',
  })
  componentPrice?: number;

  @Column({
    group: "Current Substitution Pricing",
    field: 'componentPriceDelivery',
    title: 'Current Sub Delivery Price',
    order: 8,
    pipeToken: CurrencyPipe,
    width: 150,
    filterable: true,
    filterType: 'numeric',
    sortable: true,
  })
  componentPriceDelivery?: number;

  @Column({
    group: "Substitution Price Exact Difference",
    groupHeaderClass: 'substitution-group-header',
    field: 'subExactDiff',
    title: 'Sub Exact Difference',
    order: 9,
    pipeToken: CurrencyPipe,
    width: 140,
    filterable: false,
    filterType: 'numeric',
    sortable: false,
    headerClass: 'substitution-group-start',
    class: 'substitution-group-start',
    visibleInQuickView: true,
  })
  subExactDiff?: number;

  @Column({
    group: "Substitution Price Exact Difference",
    field: 'subDeliveryExactDiff',
    title: 'Sub Delivery Exact Difference',
    order: 10,
    pipeToken: CurrencyPipe,
    width: 180,
    filterable: false,
    filterType: 'numeric',
    sortable: false,
    visibleInQuickView: true,
  })
  subDeliveryExactDiff?: number;

  defaultPrice?: number;
  defaultPriceDelivery?: number;
  comboParId?: number;
  comboName?: string;
  componentType?: string;
  defaultItemName?: string;
  restaurantId?: number;
  tierId?: number;
  sortOrder?: number;

  isUnderPriced?: boolean;
  isOverPriced?: boolean;

  constructor(substitutionException?: Partial<SubstitutionException>) {
    this.comboParId = substitutionException?.comboParId;
    this.comboName = substitutionException?.comboName || '';
    this.parItemId = substitutionException?.parItemId;
    this.itemName = substitutionException?.itemName || '';
    this.componentType = substitutionException?.componentType || '';
    this.alc = substitutionException?.alc;
    this.alcDlv = substitutionException?.alcDlv;
    this.componentPrice = substitutionException?.componentPrice;
    this.componentPriceDelivery = substitutionException?.componentPriceDelivery;
    this.defaultItemName = substitutionException?.defaultItemName || '';
    this.defaultPrice = substitutionException?.defaultPrice;
    this.defaultPriceDelivery = substitutionException?.defaultPriceDelivery;
    this.defaultSubs = substitutionException?.defaultSubs;
    this.defaultSubsDlv = substitutionException?.defaultSubsDlv;
    this.subExactDiff = substitutionException?.subExactDiff;
    this.subDeliveryExactDiff = substitutionException?.subDeliveryExactDiff;
    this.restaurantId = substitutionException?.restaurantId;
    this.tierId = substitutionException?.tierId;
    this.sortOrder = substitutionException?.sortOrder;
    this.isUnderPriced = substitutionException?.isUnderPriced;
    this.isOverPriced = substitutionException?.isOverPriced;
  }
}

export class GridRowSubstitutionException extends GridRow(
  SubstitutionException,
) {}
